import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import SubscribePage from '../pages/SubscribePage';
import LoginPage from '../pages/LoginPage';
import HomePage from '../pages/HomePage';
import SelectCaptainAndViceCaptain from '../pages/SelectCaptainAndViceCaptain';
import LiveMatches from '../pages/LiveMatches';
import MatchDetails from '../pages/MatchDetails';
import FantasyGame from '../pages/FantasyGame';
import CreateFantasyTeam from '../pages/CreateFantasyTeam';
import MyMatches from '../pages/MyMatches';
import CreatePrediction from '../pages/CreatePrediction';
import PredictionGame from '../pages/PredictionGame';
import Leaderboard from '../pages/Leaderboard';
import Profile from '../pages/Profile';
import Auth from '../component/Auth';
import EditProfile from '../pages/EditProfile';
import ErrorBoundary from '../pages/ErrorBoundary';
import SubscriptionPage2 from '../pages/NewPages/SubscriptionPage2';
import LoginPage2 from '../pages/NewPages/LoginPage2';
import HomePage2 from '../pages/NewPages/HomePage2';
import CreateFantasyTeam2 from '../pages/NewPages/CreateFantasyTeam2';
import SelectCaptainAndViceCaptain2 from '../pages/NewPages/SelectCaptainAndViceCaptain2';
import FantasyGame2 from '../pages/NewPages/FantasyGame2';
import LiveMatches2 from '../pages/NewPages/LiveMatches2';
import MatchDetails2 from '../pages/NewPages/MatchDetails2';
import MyMatches2 from '../pages/NewPages/MyMatches2';
import CreatePrediction2 from '../pages/NewPages/CreatePrediction2';
import PredictionGame2 from '../pages/NewPages/PredictionGame2';
import Leaderboard2 from '../pages/NewPages/Leaderboard2';
import ProfilePage2 from '../pages/NewPages/ProfilePage2';
import EditProfilePage2 from '../pages/NewPages/EditProfilePage2';
import LandingPage from '../pages/NewPages/LandingPage';
import LandingPage2 from '../pages/NewPages/LandingPage2';
import WinningsPage2 from '../pages/NewPages/WinningsPage2';
import MatchWinningsPage2 from '../pages/NewPages/MatchWinningsPage2';
import MatchRewardsPage2 from '../pages/NewPages/MatchRewardsPage2';
import MatchWinningsInfoPage2 from '../pages/NewPages/MatchWinningsInfoPage2';

const Routing = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <LandingPage2 />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/login",
            element: <LoginPage2 />,
            errorElement: <ErrorBoundary />
        },
        {
            path:"/subscribe",
            element:<SubscriptionPage2 />,
            errorElement:<ErrorBoundary />
        },
        {
            path: "/home",
            element:
                <Auth>
                    <HomePage2 />
                </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/live",
            element:
                <Auth>
                    <LiveMatches2 />
                </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/match-details",
            element:
                <Auth>
                    <MatchDetails2 />
                </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/my-matches",
            element:
                <Auth>
                    <MyMatches2 />
                </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/create-prediction",
            element:
                <Auth>
                    <CreatePrediction2 />
                </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/prediction-game",
            element:
                <Auth>
                    <PredictionGame2 />
                </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/winnings",
            element:
                <Auth>
                    <WinningsPage2 />
                </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path:"/match-winnings",
            element:<Auth>
                <MatchWinningsPage2 />
            </Auth>,
            errorElement:<ErrorBoundary />
        },
        {
            path:"/match-winnings-info",
            element:<MatchWinningsInfoPage2 />,
            errorElement:<ErrorBoundary />
        },
        {
            path:"/match-rewards-info",
            element:<MatchRewardsPage2 />,
            errorElement:<ErrorBoundary />
        },
        {
            path: "/profile",
            element:
                <Auth>
                    <ProfilePage2 />
                </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/edit-profile",
            element: <Auth>
                <EditProfilePage2 />
            </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "*",
            element: <Navigate to="/" />
        }

    ]);
    return (
        <RouterProvider router={router} />
    )
}

export default Routing